import { activeFacebookPageSelector } from '@mm/state/selectors/facebookPageSelector';
import { selectSessionSelector } from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import {
  BOOK_DEMO_ENTERPRISE,
  BOOK_DEMO_NON_ENTERPRISE,
  ENTERPRISE_TRAFFIC_THRESHOLD,
  BOOK_NON_SQL_DISCO_CALL,
  IN_APP_DEMO_UTM,
  LLR_DEMO_UTM,
  usCountryCode,
} from '../../../dashboard/pages/XRayOnboarding/WebsiteReportSummary/constants';
import { Routes } from '../../../routes/top-level-routes';

export const useBookDemo = () => {
  const activeCompany = useSelector(activeCompanySelector);
  const userGeodata = useSelector((state: StoreState) => state.userGeodata);
  const isSignupFromReportPage =
    activeCompany?.additionalFeatures?.includes('xray_onboarding');
  const facebookPage = useSelector(activeFacebookPageSelector);
  const { userAttributes } = useSelector(selectSessionSelector);
  const rootElement = document.getElementById('app');

  const { match } = useRouter();
  const isLLRReportUrl = match.path.includes(Routes.report.path);

  const utmTags =
    isLLRReportUrl || isSignupFromReportPage
      ? LLR_DEMO_UTM(activeCompany?.website || '')
      : IN_APP_DEMO_UTM;

  const isEligibleForDemo =
    (activeCompany?.consideredQualified ||
      userGeodata?.country_code === usCountryCode) &&
    !(
      facebookPage?.subscription ||
      activeCompany?.bookAnEnterprise ||
      userAttributes.requestedDemo
    );

  const websiteTraffic = activeCompany?.trafficData;
  const totalTraffic =
    (websiteTraffic?.trafficType?.organic || 0) +
    (websiteTraffic?.trafficType?.paid || 0);

  const discoUrl = `${BOOK_NON_SQL_DISCO_CALL}?${utmTags}`;
  const demoUrl = activeCompany?.consideredQualified
    ? totalTraffic < ENTERPRISE_TRAFFIC_THRESHOLD
      ? `${BOOK_DEMO_NON_ENTERPRISE}?${utmTags}`
      : `${BOOK_DEMO_ENTERPRISE}?${utmTags}`
    : discoUrl;

  return {
    isEligibleForDemo,
    rootElement,
    websiteTraffic,
    totalTraffic,
    demoUrl,
    discoUrl,
  };
};
